import { Button, styled, Typography } from '@mui/material';
import { TFunction } from 'i18next';
import React from 'react';
import { Trans } from 'react-i18next';
import { ErrorReference, GraphQlRequestErrorCode } from '../../../../api/types';
import {
  useAuthenticationServiceContext,
  useDomainContext,
  useOriginalRoleViewAuthorizationServiceContext,
  useSimulatedRoleContext,
  useSimulatedRoleSetterContext,
} from '../../../../context/contexts';
import { Error } from './Error';
import ErrorTechnicalDetails from './ErrorTechnicalDetails';

const StyledButton = styled(Button)`
  margin: 5px;
  background-color: #00a599;
  &:hover {
    background-color: rgba(27, 113, 107);
  }
`;

interface InsufficientPermissionsErrorComponentProps {
  resetError: () => void;
  // Optional: this screen is also rendered as a client-side permission gate,
  // where there is no underlying GraphQL error to report.
  errorCode?: GraphQlRequestErrorCode | null;
  errorReference?: ErrorReference | null;
}

export const InsufficientPermissionsErrorComponent = (
  props: InsufficientPermissionsErrorComponentProps
) => {
  const { resetError, errorCode = null, errorReference = null } = props;
  const simulatedRole = useSimulatedRoleContext();
  const authorizationService = useOriginalRoleViewAuthorizationServiceContext();
  const simulatedRoleSetter = useSimulatedRoleSetterContext();
  const authService = useAuthenticationServiceContext();
  const domain = useDomainContext();
  const stopRoleSimulation = () => {
    simulatedRoleSetter(null);
    //location.reload();
    resetError();
  };
  const logOut = () => {
    localStorage.clear();
    void authService.logOutUser(domain);
  };
  return (
    <Error
      title={{ key: 'pages:errorBoundary.insufficientPermissions' }}
      message={() => (
        <>
          <Typography variant="h5">
            <Trans
              i18nKey="pages:errorBoundary.insufficientPermissionsExplanation"
              components={[<br />]}
            />
          </Typography>
          <ErrorTechnicalDetails
            errorCode={errorCode}
            errorReference={errorReference}
          />
        </>
      )}
      exit={(t: TFunction) => (
        <>
          {authorizationService.canManageAllDomains() ? (
            <StyledButton
              disabled={simulatedRole === null}
              variant="contained"
              color="primary"
              onClick={stopRoleSimulation}
            >
              {t('pages:errorBoundary.stopSimulation')}
            </StyledButton>
          ) : null}
          <StyledButton variant="contained" color="primary" onClick={logOut}>
            {t('pages:verifyEmail.logoutButtonText')}
          </StyledButton>
        </>
      )}
    />
  );
};

export default InsufficientPermissionsErrorComponent;
